import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'

const KEY = 'consultation-calendar'

@Component({
	selector: 'atyl-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss'],
})

@Stringable({
	path: 'views/pages/consultation/calendar/calendar',
	key: KEY,
})
export class CalendarComponent implements OnInit {
	@Input() consultationList: any
	@Input() hiddenElements: boolean = false;
    @Input() isvisite: boolean = false;
    @Input() showAllDays: Boolean=false;
   
	@StringableValues(KEY) strings: any
	clicked: boolean = false;
	currentConsultationDay: any = null;
	currentConsultation: any = null;
    
	@Output() backButtonClicked = new EventEmitter<any>();
	
	beginHour:number=800
    beginEnd:number=2000;
    priodTranch:number=10;
    priodAjustTranch:number=40;
	periods:any=[];
	
	constructor(
		private changeDetectorRef: ChangeDetectorRef
	) { }

	ngOnInit(): void {
		console.log("CalendarComponent ngOnInit",this.consultationList,this.isvisite);
		this.getInitLabelPeriod();
	}


	ngOnChanges() {
		this.changeDetectorRef.detectChanges()
	}

	showDays(event: any) {
		this.backButtonClicked.emit(this.hiddenElements)
		this.changeDetectorRef.detectChanges()
	}
	consultationSelected(event: any, day: any) {

		this.currentConsultationDay = day
		this.currentConsultation = event
		this.hiddenElements = false
		this.backButtonClicked.emit(this.hiddenElements)
		this.changeDetectorRef.detectChanges()
	}
	createVisite(event: any) {
	}
	
	getInitLabelPeriod() {
				this.periods=[];
				let count=0;
				let tolalM:number=720;
				while(this.beginHour<=this.beginEnd) {
					let hm =('0' + this.beginHour).slice(-4);

		            let vingtieme = this.beginHour % 20 ? '-' :'- '+parseInt(hm.substring(2,4))
					
				    
					let min:number=this.getTimeMinute(hm)-8*60;
					let max:number=8*60+tolalM-(this.getTimeMinute(hm)+10);
									
					let top:number=min*100/tolalM;
					let bottom:number=max*100/tolalM;
								
					let hmo={
						inset: {
							"top": top,
							"bottom": bottom,
							"left":0,
							"right" :0
						},
						period: hm,
						label: ((this.beginHour % 100)==0) ? this.getTimeLabel(hm) : vingtieme,
						
						
					};
					//console.log('getInitLabelPeriod hmo.label:',hmo.label,'\ntaille hmo.label:',(hmo.label).length);
		            
					this.periods.push(hmo);
					this.beginHour+= this.priodTranch;
					count++;
					if (count==6) {
						count=0;
						this.beginHour+=this.priodAjustTranch;
					}
				
				
					/*console.log("periods defaults",
						this.periods);*/
				
				}
			}
			

			getTimeMinute(hm:string) {
					let h:string=hm.substr(0,2);
					let m:string=hm.substr(2);
					let min:number=parseInt(h)*60+parseInt(m);
					return min;
			}

			

			getTimeLabel(hm:string) {
				let h:string=hm.substr(0,2);
				let m:string=hm.substr(2);
				return h + ":" + m;
			}
}
